export default {
      id: "i-bell-usage",
      viewBox: "0 0 22 24",
      url: __webpack_public_path__ + "img/sprite.svg#i-bell",
      toString: function () {
        return this.url;
      }
    }